import api from "lib/api";

export const getDepartment = async (params = {}) => {
  return await api.post("/v1/organization/getOrganization", params);
};

export const createDepartment = async (params = {}) => {
  return await api.post("/v1/organization/createOrganization", params);
};

export const updateDepartment = async (params = {}) => {
  return await api.post("/v1/organization/updateOrganization", params);
};

export const deleteDepartment = async (params = {}) => {
  return await api.post("/v1/organization/manageOrganizationStatus", params);
};

export const getOrganizationLevelList = async (params = {}) => {
  return await api.post(
    "/v1/organizationLevel/getAllOrganizationLevel",
    params
  );
};
export const getOrganizationLevel = async (params = {}) => {
  return await api.post("/v1/organizationLevel/getOrganizationLevel", params);
};

export const createOrganizationLevel = async (params = {}) => {
  return await api.post(
    "/v1/organizationLevel/createOrganizationLevel",
    params
  );
};
export const updateOrganizationLevel = async (params = {}) => {
  return await api.post(
    "/v1/organizationLevel/updateOrganizationLevel",
    params
  );
};
export const deleteOrganizationLevel = async (params = {}) => {
  return await api.post(
    "/v1/organizationLevel/deleteOrganizationLevel",
    params
  );
};
